import React from 'react'
import styled from 'styled-components'
import { device } from '../../../config/theme/breakpoints';

const ContainerDetail = styled.div<{ className: string }>`
    width: 100%;
    border-bottom: 1px solid ${p => p.theme.palette.text.gray};
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    text-transform: uppercase;

    > div {
        width: 100%;
        text-align: center;

        @media ${device.tablet}{
            width: 50%;
            text-align: left;
        }
    }

    > div:nth-child(2){
        padding-left: 0;
        color: ${p => p.theme.palette.primary.main};
        
        @media ${device.tablet}{
            padding-left: 20px;
        }
    }

    ${p => p.className}
`

interface IOwnProps {
    title: string;
    description: string;
    className?: string;
}

const ItemDetail: React.FunctionComponent<IOwnProps> = ({ title, description, className = '' }) => {
  return (
    <ContainerDetail className={className}>
        <div><p><b>{title}</b></p></div>
        <div><p>{description}</p></div>
    </ContainerDetail>
  )
}

export default ItemDetail